module.exports = __webpack_public_path__ + "static/media/web_shared-ux@2x.e0896f9f.png";